import React, { useState } from "react";
import fondo from "./ismaael.jpeg";
import "./ComicPagina.css";
import "./Autores.css";
import { Link, useNavigate } from "react-router-dom";
import MenuPrincipal from "./MenuPrincipal";

// 📦 importar todos los archivos dentro de /pages automáticamente
const pages = require.context("./pages", true, /\.jsx$/);
// 🔍 función para leer los autores únicos
const obtenerAutores = () => {
  const autores = [];

  pages.keys().forEach((path) => {
    try {
      const modulo = pages(path);
      const info = modulo.infoManga;

      if (info?.info?.artistas)
        autores.push(info.info.artistas.trim());

    } catch (error) {
      console.error("Error leyendo:", path, error);
    }
  });

  return [...new Map(autores.map(a=>[a.toLowerCase(),a])).values()];
};

export default function Autores() {
  const navigate = useNavigate();
  const [letraSeleccionada, setLetraSeleccionada] = useState("A");
const letras = [
  "A","B","C","D","E","F","G","H","I","J","K","L",
  "M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"
];
  const autores = obtenerAutores().sort();

  // Filtrar por la letra seleccionada
  const autoresFiltrados = autores.filter((a) =>
    a.toUpperCase().startsWith(letraSeleccionada)
  );

  return (
    <div className="autores-page">
      {/* CABECERA */}
      <header
        className="header-fondo"
        style={{
          background: `url(${fondo}) no-repeat center center/cover`,
          padding: "40px 0",
          textAlign: "center",
          color: "#fff",
        }}
      >
<h1
  className="titulo"
  onClick={() => navigate("/")}
  style={{ cursor: "pointer" }}
>
  TMOXNight
</h1>
    

    <MenuPrincipal />

      </header>

      {/* PAGINACIÓN ALFABÉTICA */}
      <div className="letras-container">
        {letras.map((letra) => (
          <button
            key={letra}
            className={`letra-btn ${
              letra === letraSeleccionada ? "active" : ""
            }`}
            onClick={() => setLetraSeleccionada(letra)}
          >
            {letra}
          </button>
        ))}
      </div>

      {/* LISTA DE AUTORES */}
      <main className="autores-contenido">
        <h2 className="titulo-autores">Autores - {letraSeleccionada}</h2>
        <div className="grid-tags">
          {autoresFiltrados.length > 0 ? (
            autoresFiltrados.map((autor, i) => (
              <Link
  key={i}
  to={`/buscar?autor=${encodeURIComponent(autor)}`}
  className="tag-autor"
>
  {autor}
</Link>

            ))
          ) : (
            <p className="sin-autores">Sin autores en esta letra.</p>
          )}
        </div>
      </main>

      {/* FOOTER */}
      <footer>
        <p>&copy; 2024 TMOXNight. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
